import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAdminAuthStore } from '../../store/adminAuthStore';
import { firstAdminPath } from '../../config/permissions.config';
import Button from '../../components/ui/Button';
import Spinner from '../../components/ui/Spinner';

const AdminLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAdminAuthStore((s) => s.login);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      toast.success('Signed in.');
      const path = firstAdminPath(useAdminAuthStore.getState().has, useAdminAuthStore.getState().admin?.permissions ?? []) ?? '/admin/forbidden';
      navigate(path, { replace: true });
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Login failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-gray-100)] px-4">
      <div className="w-full max-w-sm bg-white rounded-lg shadow p-8">
        <h1 className="text-xl font-semibold text-[var(--color-gray-900)] mb-1">Admin Console</h1>
        <p className="text-sm text-[var(--color-gray-600)] mb-6">Dynamic hierarchy &amp; access management</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[var(--color-gray-700)] mb-1">Username</label>
            <input
              className="w-full rounded-md border border-[var(--color-gray-300)] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-primary-light)]"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--color-gray-700)] mb-1">Password</label>
            <input
              type="password"
              className="w-full rounded-md border border-[var(--color-gray-300)] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-primary-light)]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button type="submit" disabled={submitting} className="w-full">
            {submitting ? <Spinner size={16} /> : 'Sign in'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
